module.exports = __webpack_public_path__ + "static/img/loading1.e1d27b4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/layout/loading1.gif
// module id = Ly+V
// module chunks = 15